import React, { Fragment } from 'react'
import pure from 'recompose/pure'
import { connect } from 'react-redux'
import colors from 'aria-viewer/tour/constants/style/colors'
import Browser from 'aria-viewer/utils/mobileDetect'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { closeModal } from '../modalActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import ModalTypes from '../constants/ModalTypes'
import { CTAPrompt } from 'aria-viewer/ctaPrompt'
import compose from 'recompose/compose'

const S = {
    modalContainer: {
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
    },
    baseModal: Object.assign({}, styleguide.scrollable, {
        position: 'absolute',
        top: '50%',
        width: '80%',
        maxHeight: '90%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#fff',
        borderRadius: 4,
        boxShadow: '0 0.4em 1.4em 0 rgba(0, 0, 0, 0.5)',
        padding: '1.8em 1em 1.6em',
    }),
    baseItemContainer: {
        position: 'absolute',
        zIndex: 2005,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    },
    baseItemDesktopBg: {
        background: colors.dark_blue_transparent_9,
    },
    tabletModal: {
        width: '50%',
        overflow: 'auto',
        minWidth: 385,
    },
    nonTabletModal: {
        width: '25%',
        overflow: 'auto',
        minWidth: 385,
    },
    modalScroller: {
        width: '98%',
        margin: 'auto',
        maxHeight: 'calc(80vh)',
        padding: '0 0.3em 0.5em',
    },
}

const modalDesktopScrollerStyle = Object.assign({}, S.modalScroller, { width: '85%' })

const stopPropagation = e => e.stopPropagation()

const ModalsContainer = ({ registry, modalStack, closeModal, desktop = false }) => {
    let modalStyle = S.baseModal
    if (desktop) {
        modalStyle = Object.assign({}, modalStyle, Browser.tablet() ? S.tabletModal : S.nonTabletModal)
    }

    return (
        <Fragment>
            {modalStack.size > 0 && (
                <div id="modalsContainer" style={S.modalsContainer}>
                    {// if a modal does not have an independent container,
                    // return its representation surrounded by a div inside
                    // these containers (otherwise, we can assume it is
                    // rendering itself within the app as needed)
                    modalStack
                        .filter(modal => !modal.content.hasIndependentContainer)
                        .map((modal, index) => {
                            // for the old way of displaying modals based on type,
                            // return based on ModalComponentType/etc.
                            // Default now is ModalTypes.FULLSCREEN

                            if (modal.type !== ModalTypes.FULLSCREEN) {
                                const ModalComponentType = registry.modals[modal.type]
                                const submitAction =
                                    modal.content.submit && registry.actions[modal.content.submit.action]

                                // since we're looking in the "registry", make sure that
                                // the modal type we need exist or React will die
                                if (!registry.modals[modal.type]) {
                                    throw new Error(
                                        'Invalid modal type passed to modals container! ' +
                                            'Cannot render ModalsContainer'
                                    )
                                }

                                return (
                                    <div
                                        key={`modalContainer${index}`}
                                        onClick={closeModal}
                                        style={Object.assign(
                                            {},
                                            S.baseItemContainer,
                                            modal.content.containerStyle,
                                            desktop ? S.baseItemDesktopBg : {}
                                        )}
                                    >
                                        <div
                                            style={Object.assign({}, modalStyle, modal.content.contentStyle)}
                                            onClick={stopPropagation}
                                        >
                                            <div style={desktop ? modalDesktopScrollerStyle : S.modalScroller}>
                                                <ModalComponentType
                                                    content={modal.content}
                                                    desktop={desktop}
                                                    submitAction={submitAction}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                </div>
            )}
            <CTAPrompt isModal={true} />
        </Fragment>
    )
}

export default compose(
    connect(
        mapSelectorsToProps(['modalStack']),
        {
            closeModal,
        }
    ),
    pure
)(ModalsContainer)
